import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
  return (
    <div className="gettouch p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h2>Let’s Talk About Your Project</h2>
            </div>
            <p>
              Let's Shape Your Project Together! Our Web3 developers will assist
              you in taking your business to the digital space. Our Web 3.0
              projects provide 100% client satisfaction rates and assist
              businesses in achieving their goals. Fill out the form, and click
              "Get in Touch" to start the process.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
